import { IndicatorType } from '../../constants/common'
import IndicatorBaseConfig from './indicatorBaseConfig'

export type Options = {
  period: number
}

export type Attrs = Options

export class MFIConfig extends IndicatorBaseConfig {
  static type = IndicatorType.Mfi
  static abbreviation = 'mfi'
  static label = 'Money Flow Index'
  static shortLabel = 'MFI'
  static optionsOrder = ['period'] as const
  static optionsLabels = { period: 'Period' }
  static inputsOrder = this.optionsOrder
  static inputsLabels = this.optionsLabels
}
